export const GET_DATA_SOURCES = 'GET_DATA_SOURCES'
export const GET_DATA_SOURCES_FAILED = 'GET_DATA_SOURCES_FAILED'
export const GET_DATA_SOURCES_SUCCEEDED = 'GET_DATA_SOURCES_SUCCEEDED'

export const SYNC_DATA_SOURCE = 'SYNC_DATA_SOURCE'
export const SYNC_DATA_SOURCE_FAILED = 'SYNC_DATA_SOURCE_FAILED'
export const SYNC_DATA_SOURCE_SUCCEEDED = 'SYNC_DATA_SOURCE_SUCCEEDED'

export const GET_EMAIL_PROVIDERS = 'GET_EMAIL_PROVIDERS'
export const GET_EMAIL_PROVIDERS_FAILED = 'GET_EMAIL_PROVIDERS_FAILED'
export const GET_EMAIL_PROVIDERS_SUCCEEDED = 'GET_EMAIL_PROVIDERS_SUCCEEDED'

export const CONNECT_DATA_SOURCE = 'CONNECT_DATA_SOURCE'
export const CONNECT_DATA_SOURCE_FAILED = 'CONNECT_DATA_SOURCE_FAILED'
export const CONNECT_DATA_SOURCE_SUCCEEDED = 'CONNECT_DATA_SOURCE_SUCCEEDED'

export const DISCONNECT_DATA_SOURCE = 'DISCONNECT_DATA_SOURCE'
export const DISCONNECT_DATA_SOURCE_FAILED = 'DISCONNECT_DATA_SOURCE_FAILED'
export const DISCONNECT_DATA_SOURCE_SUCCEEDED = 'DISCONNECT_DATA_SOURCE_SUCCEEDED'

export const GET_PLAID_CONNECTIONS = 'GET_PLAID_CONNECTIONS'
export const GET_PLAID_CONNECTIONS_FAILED = 'GET_PLAID_CONNECTIONS_FAILED'
export const GET_PLAID_CONNECTIONS_SUCCEEDED = 'GET_PLAID_CONNECTIONS_SUCCEEDED'

export const GET_WORKATO_CONNECTIONS = 'GET_WORKATO_CONNECTIONS'
export const GET_WORKATO_CONNECTIONS_FAILED = 'GET_WORKATO_CONNECTIONS_FAILED'
export const GET_WORKATO_CONNECTIONS_SUCCEEDED = 'GET_WORKATO_CONNECTIONS_SUCCEEDED'
